export const route = {
  globalSuffix: ' - Aplicație administrare contracte',

  LoginRouteTitle: 'Autentificare',
  LogoutRouteTitle: 'Deconectare',
  Dashboard: 'Pagina principală',

  ContractsRouteTitle: 'Contracte',
  ContractsCreateRouteTitle: 'Adăugare contract',
  ContractsUpdateRouteTitle: 'Actualizare contract',
  ContractDetailsRouteTitle: 'Detalii contract',
  ContractHistoryRouteTitle: 'Istoric contract',

  UpdateActAditionalForContractRouteTitle: 'Actualizare act adițional',

  PartnersGridRouteTitle: 'Parteneri',
  PartnersCreateRouteTitle: 'Creare partener',
  PartnersDetailsRouteTitle: 'Detalii partener',

  GrupareContracteIndexRouteTitle: 'Acorduri-cadru',
  GrupareContracteCreateRouteTitle: 'Creare acord-cadru',
  GrupareContracteUpdateRouteTitle: 'Actualizare acord-cadru',
  GrupareContracteDetailsRouteTitle: 'Detalii acord-cadru',

  UserNotificationsRouteTitle: 'Notificări',
  NotificationSubscriptionIndexRouteTitle: 'Subscripții notificări',

  LicitatieAchizitieIndexRouteTitle: 'Proceduri de achiziție',
  LicitatieAchizitieCreateRouteTitle: 'Creare procedură de achiziție',
  LicitatieAchizitieUpdateRouteTitle: 'Actualizare procedură de achiziție',
  LicitatieAchizitieDetailsRouteTitle: 'Detalii procedură de achiziție',

  UsersIndexRouteTitle: 'Utilizatori',
  UsersCreateRouteTitle: 'Creare utilizator',
  UsersUpdateRouteTitle: 'Actualizare utilizator',
  UsersDetailsRouteTitle: 'Detalii utilizator',

  ContractTypesIndexRouteTitle: 'Tipuri de contracte',
  ContractTypesCreateRouteTitle: 'Adăugare tip contract',
  ContractTypesEditRouteTitle: 'Editare tip contract',

  ConfigurareAplicatieRouteTitle: 'Configurare aplicație',
  AccesSecuritateRouteTitle: 'Acces și securitate',

  MappingAdRolesIndexRouteTitle: 'Mapări roluri acces',
  MappingAdRolesCreateRouteTitle: 'Adăugare mapare rol acces',
  MappingAdRolesUpdateRouteTitle: 'Actualizare mapare rol acces',
  MappingAdRolesDetailsRouteTitle: 'Detalii mapare rol acces'
}
